module.exports = __webpack_public_path__ + "static/media/background-img.96f64007.png";